<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="content_wrap container">
      <div class="content_title">
        <titleConfig
          :title="langSet == 'cn' ? '历届回顾' : 'Previous Exhibitions'"
          :type="2"
        ></titleConfig>
      </div>
      <div class="list flex flex_wrap">
        <div
          class="item"
          v-for="(item, index) in list"
          :key="index"
          @click="toDetails(item)"
        >
          <div class="img-wrap flex flex_content_center flex_items_center">
            <img class="img" :src="item.img" alt="" />
          </div>
          <div class="title">
            {{ langSet == "cn" ? item.title : item.en_title }}
          </div>
          <div class="text">
            <div>{{ langSet == "cn" ? item.address : item.en_address }}</div>
            <div>{{ item.time }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import { reviewList } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      list: [],
      metaData: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    //25.9.16 获取历届回顾 dxm
    this.getList();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getList() {
      const res = await reviewList();
      this.list = res.data.lists;
    },
    //25.9.16 跳转详情 dxm
    toDetails(e) {
      let { http_type, http_url, http_url_en, id } = e;
      if (http_type == "内部跳转") {
        this.$router.push({
          path: "/reviewDetails",
          query: {
            id,
          },
        });
      }else{
        window.open(this.langSet == "cn" ? http_url : http_url_en, "_blank");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content_wrap {
  padding: 80px 0;
  min-height: 500px;
  .content_title {
    margin-bottom: 31px;
  }
  .list {
    .item {
      width: 300px;
      min-height: 271px;
      padding: 15px;
      font-size: 14px;
      color: #44435a;
      line-height: 20px;
      cursor: pointer;
      margin: 0 25px 30px 0;
      background: #f7f8fa;
      box-sizing: border-box;
      border: 1px solid #f7f8fa;
      transition: all 0.5s ease-in-out;
      &:nth-child(4n) {
        margin-right: 0;
      }
      &:hover {
        background: #e9eaf2;
        border-radius: 15px;
      }
      .title {
        font-size: 18px;
        color: #2c2c2e;
        line-height: 25px;
        padding-bottom: 8px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .img-wrap {
        width: 100%;
        height: 168px;
        margin-bottom: 15px;
        background: #fff;
        .img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .content_wrap .list .item {
    width: calc((100% - 6%) / 4);
    margin-right: 2%;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    padding: 0.58rem 0;
    .content_title {
      margin-bottom: 0.58rem;
    }
    .list .item {
      width: 100%;
      font-size: 0.27rem;
      padding: 0.29rem;
      margin-right: 0;
      margin-bottom: 0.58rem;
      .img-wrap {
        height: 3.85rem;
        margin-bottom: 0.29rem;
      }
      .title {
        font-size: 0.35rem;
        line-height: 0.48rem;
      }
      .text {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>